import { render, staticRenderFns } from "./NetworkIssue.vue?vue&type=template&id=494fadcb&"
import script from "./NetworkIssue.vue?vue&type=script&lang=js&"
export * from "./NetworkIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports